import { inject, Pipe, PipeTransform } from '@angular/core';
import { ITimeInterval, TIME_INTERVAL_TRANSFORMER_SERVICE } from '@luggagehero/shared/interfaces';
import { Observable } from 'rxjs';

@Pipe({ name: 'timeInterval', standalone: true })
export class TimeIntervalPipe implements PipeTransform {
  private transformer = inject(TIME_INTERVAL_TRANSFORMER_SERVICE);

  transform(
    value: ITimeInterval[],
    short = true,
    timeOnly = false,
    ...components: ('from' | 'to')[]
  ): Observable<string> {
    return this.transformer.transform(value, short, timeOnly, ...components);
  }
}
